makeErrorEnum = require 'app/scripts/lib/make-error-enum'

module.exports = makeErrorEnum 'CreditCardForm', [
  'InvalidField'
  'PostError'
  'PollError'
]
